import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getCodigosPostalesRestriccionesMovilidad } from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* CPS_LOAD_RESTRICCIONES_MOVILIDAD() {
  try {
    const cpsData = yield call(getCodigosPostalesRestriccionesMovilidad)
    if (cpsData.ok) {
      yield put({
        type: actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_SUCCEEDED,
        payload: cpsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Códigos Postales')
      yield put({
        type: actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_REQUESTED, CPS_LOAD_RESTRICCIONES_MOVILIDAD),
  ])
}
